// TIME CAPSULE GALLERY
// Add a new { src, alt } entry below for every photo you want in the gallery.
//
// For photos already sitting in src/assets: import them at the top of this
// file (like kps2025 below), then reference the imported name.
//
// For new photos: the simplest way is to drop the image file straight into
// public/assets/gallery/ and reference it as a plain string path, e.g.
//   { src: "/assets/gallery/social-2026.jpg", alt: "KPS social night 2026" }
// — same pattern already used for the exec team photos in Carousel.js.
//
// Right now there's just one placeholder photo below so you can see the
// gallery working. Swap it out and add more whenever you're ready.
export const galleryPhotos = [
    { src: "/assets/gallery/annualdinner25.JPG", alt: "Annual Dinner 2025" }, 
    { src: "/assets/gallery/cruise26.PNG", alt: "KPS Cruise 2026" },
    { src: "/assets/gallery/kcore25.JPG", alt: "K-Core 2025" },
    { src: "/assets/gallery/kozykorner26.jpg", alt: "Kozy Korner 2026" },
    { src: "/assets/gallery/RPD_26T1.JPG", alt: "RPD 2026" },
    { src: "/assets/gallery/RPD_26T2.JPG", alt: "RPD 2026" },
]